<script lang="js">

export default {
    data() {
        return {};
    },
    methods: {},
    components: { },
};
</script>

<template>
  <div class="container-fluid p-0 vh-100">
    <router-view class="" />
  </div>
</template>
